import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Button, PrimaryButton } from "../../../ui/Button/Button";
import { customPartFormId } from "../CustomParts/CustomPartForm";
import { vehicleLoaderFormId } from "../VehicleMapping/VehicleLoader";
import { packageInfoFormId } from "./PackageInfo";

export const Footer: FunctionComponent<{
  hide: VoidFunction;
  isSending: boolean;
  modelsAreLoading: boolean;
  partListTabIndex: number;
  selectTab: (index: number) => void;
  selectedVehiclesCount: number;
  shouldFetchVehicles: boolean;
  tabIndex: number;
  vehicleManufacturerIds: number[];
  vehicleYearIds: number[];
}> = ({
  hide,
  isSending,
  modelsAreLoading,
  partListTabIndex,
  selectTab,
  selectedVehiclesCount,
  shouldFetchVehicles,
  tabIndex,
  vehicleManufacturerIds,
  vehicleYearIds,
}) => {
  const { t } = useTranslation();

  return (
    <footer className="new-package-dialog__footer">
      {tabIndex === 0 &&
        (partListTabIndex === 1 ? (
          <>
            <Button
              onClick={(): void => {
                const form = document.getElementById(
                  customPartFormId
                ) as HTMLFormElement;
                if (form) {
                  form.reset();
                }
              }}
              aria-label="showParts"
            >
              {t("packageEditor.showParts")}
            </Button>
            <PrimaryButton
              aria-label="addCustomPart"
              form={customPartFormId}
              type="submit"
            >
              {t("packageEditor.addCustomPart")}
            </PrimaryButton>
          </>
        ) : (
          <>
            <Button aria-label="close" onClick={hide}>
              {t("packageEditor.close")}
            </Button>
            <PrimaryButton
              onClick={(): void => {
                selectTab(1);
              }}
              aria-label="save"
            >
              {t("packageEditor.next")}
            </PrimaryButton>
          </>
        ))}
      {tabIndex === 1 &&
        (shouldFetchVehicles ? (
          <>
            <Button
              onClick={(): void => {
                selectTab(0);
              }}
              aria-label="close"
            >
              {t("packageEditor.parts")}
            </Button>
            <PrimaryButton
              disabled={
                !vehicleYearIds.length || !vehicleManufacturerIds.length
              }
              aria-label="save"
              busy={modelsAreLoading}
              form={vehicleLoaderFormId}
              type="submit"
            >
              {t("packageEditor.fetchVehicles")}
            </PrimaryButton>
          </>
        ) : (
          <>
            <Button
              onClick={(): void => {
                selectTab(0);
              }}
              aria-label="close"
            >
              {t("packageEditor.parts")}
            </Button>
            <PrimaryButton
              onClick={(): void => {
                selectTab(2);
              }}
              aria-label="save"
              disabled={!selectedVehiclesCount}
            >
              {t("packageEditor.next")}
            </PrimaryButton>
          </>
        ))}
      {tabIndex === 2 && (
        <>
          <Button
            onClick={(): void => {
              selectTab(1);
            }}
            aria-label="close"
          >
            {t("packageEditor.vehicles")}
          </Button>
          <PrimaryButton
            aria-label="save"
            busy={isSending}
            form={packageInfoFormId}
            type="submit"
          >
            {t("packageEditor.createPackage")}
          </PrimaryButton>
        </>
      )}
    </footer>
  );
};
